import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { combineReducers } from 'redux'

// ----------------- reducers
import user from './user/userReducer'
import notification from './notification/notificationReducer'
import customer from './customer/customerReducer'
import productReducer from './product/productReducer'
import ordersReducer from './orders/orderReducer'
import orderProcess from './process/processReducer'
import announcement from './announcement/announcementReducer'
import fileStorage from './storage/storageReducer'
import ticketReducer from './tickets/ticketReducer'
const persistConfig = {
    key: 'root',
    storage,
    whiteList: ['user'],
}

const rootReducer = combineReducers({
    user,
    customer,
    notification,
    product: productReducer,
    orders: ordersReducer,
    tickets: ticketReducer,
    orderProcess,
    announcement,
    fileStorage,
})

export default persistReducer(persistConfig, rootReducer)
